import { render, staticRenderFns } from "./OrderByItem.vue?vue&type=template&id=9e8b603e"
import script from "./OrderByItem.vue?vue&type=script&lang=js"
export * from "./OrderByItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports